import { TPO_SIGNUP_STEP_CONDITION_EXPRESSION_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const tpoSignupStepConditionExpressionSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TPO_SIGNUP_STEP_CONDITION_EXPRESSION_SCHEMA_ACTION_TYPE.GET:
      return payload || initialState;

    default:
      return state;
  }
};

export default tpoSignupStepConditionExpressionSchemaReducer;
